import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Amount } from 'ib/internetbank-core/ib-models/amount';

import { HttpClientExtension } from '../../../common/services/http-client-extension.service';
import { Product } from '../../../products/products.model';
import { OperationConfirmation } from '../../../shared/confirmation/core/models/operation-confirmation.model';

import {
	InsuranceSportConfirmDoneData,
	InsuranceSportCreateData,
	InsuranceSportForm,
	InsuranceSportPremiumSum,
} from './insurance-sport-create-wizard.model';


@Injectable({ providedIn: 'root' })
export class InsuranceSportCreateWizardService {

	public url: string = 'rest/biz/insurance/sport';

	constructor(private http: HttpClientExtension) { }

	public getInfo(insuranceId: number): Observable<InsuranceSportForm> {
		return this.http.get<InsuranceSportForm>(`${this.url}/${insuranceId}`);
	}

	public create(data: InsuranceSportCreateData): Observable<void> {
		return this.http.post<void>(`${this.url}/agreement/create/v2`, data);
	}

	public confirm(operationConfirmation: OperationConfirmation | undefined): Observable<InsuranceSportConfirmDoneData> {
		return this.http.post<InsuranceSportConfirmDoneData>(`${this.url}/agreement/confirm/v2`, operationConfirmation);
	}

	public confirmCreate(actionId: number): Observable<void> {
		return this.http.post<void>(`${this.url}/agreement/confirm-create?actionId=${actionId}`, null);
	}

	public confirmDone(operationConfirmation: OperationConfirmation | undefined): Observable<InsuranceSportConfirmDoneData> {
		return this.http.post<InsuranceSportConfirmDoneData>(`${this.url}/agreement/confirm-done`, operationConfirmation);
	}

	public getPremiumSum(body: InsuranceSportPremiumSum): Observable<Amount> {
		return this.http.post<Amount>(`${this.url}/premium/sum/calculate`, body);
	}

	public getSourceList(): Observable<Array<Product>> {
		return this.http.get<Array<Product>>(`${this.url}/agreement/sources`);
	}

	public getPdfAcceptance(id: number): Observable<Blob> {
		return this.http.get<Blob>(`${this.url}/acceptance/pdf/${id}`, { responseType: 'blob' as 'json' });
	}

	public acceptanceCreate(insuranceId: number): Observable<{ actionId: number }> {
		return this.http.post<{ actionId: number }>(`${this.url}/acceptance/create`, { insuranceId });
	}

	public acceptanceConfirm(actionId: number): Observable<OperationConfirmation> {
		return this.http.post<OperationConfirmation>(`${this.url}/acceptance/confirm-create?actionId=${actionId}`, null);
	}

	public acceptanceConfirmDone(operationConfirmation: OperationConfirmation | undefined): Observable<void> {
		return this.http.post<void>(`${this.url}/acceptance/confirm-done`, operationConfirmation);
	}

	public acceptanceSign(actionId: number): Observable<void> {
		return this.http.post<void>(`${this.url}/acceptance/sign`, { actionId });
	}

	public checkClientPersonalDataAgreement(): Observable<boolean> {
		return this.http.get<boolean>(`${this.url}/acceptance/enabled`);
	}
}
